// 支持多个业务线不同回调

import {mapState} from 'vuex';

export default {
    computed: {
        ...mapState({
            // sid: state => state.token
        })
    },
    methods: {
        // CA 课程详情页 咨询回调
        caLearnDetailConsult() {
            openJesongChatByGroup(36563, 67728);
        }
    }
};
